import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sports';

const categoryIconMap: Record<string, string> = {
  football: 'ri-football-line',
  basketball: 'ri-basketball-line',
  tennis: 'ri-trophy-line',
  esports: 'ri-gamepad-line',
  baseball: 'ri-riding-line',
};

const categoryColors: Record<string, string> = {
  football: 'bg-primary-500',
  basketball: 'bg-accent-500',
  tennis: 'bg-secondary-500',
  esports: 'bg-primary-600',
  baseball: 'bg-accent-600',
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门赛事分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            覆盖全球30+体育项目，数千场赛事实时更新，选择您喜爱的运动项目
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${categoryColors[cat.slug] || 'bg-primary-500'} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${categoryIconMap[cat.slug] || 'ri-football-line'} text-white text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500">
                {cat.matchCount} 场赛事
              </p>
              <div className="absolute top-4 right-4 w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-line text-primary-500 text-sm"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}